import React, { useEffect, useState } from "react";
import { apis as api } from "../../services/api.action";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { cnt } from "../../services/constant.action";
import { BOM } from "../../services/defined.action";
import appLabel from "../../config/appLabel";
import OtherContacts from "./OtherContacts.comp";
import appStatic from "../../config/appStaticData";
import Logo from "../../assets/img/logoLogin/2022-10-FACTOReX-LOGO-DESIGN-3.png"; // Assume a logo image is available in the assets folder
import { BgImgFac } from "../layouts/Facility"; // Import the background component

export const EditProspectiveCompany = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [companyDetail, setCompanyDetail] = useState({});
  const [otherContactData, setOtherContactData] = useState([]);
  const [primaryData, setPrimaryData] = useState({});
  const [shippingData, setShippingData] = useState({});
  const [billingData, setBillingData] = useState({});
  const [isFunder, setIsFunder] = useState(false);
  const [bankData, setBankData] = useState([]);
  const [isIndividual, setIsIndividual] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [provincePrimaryData, setProvincePrimaryData] = useState([]);
  const [provinceShippingData, setProvinceShippingData] = useState([]);
  const [provinceBillingData, setProvinceBillingData] = useState([]);
  const [cityPrimaryData, setCityPrimaryData] = useState([]);
  const [cityShippingData, setCityShippingData] = useState([]);
  const [cityBillingData, setCityBillingData] = useState([]);
  const [isShipAsPrim, setIsShipAsPrim] = useState(false);
  const [isBillAsPrim, setIsBillAsPrim] = useState(false);
  const [tempFile, setTempFile] = useState(false);
  const [docCategory, setDocCategory] = useState("");
  const [profileId, setProfileId] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [compToken, setCompToken] = useState(null);

  const [bankList, setBankList] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (token) {
      getDetailById(token);
      setCompToken(token);
      getBanks();
    } else {
      BOM.AlertMsg(cnt.DANGER, "Token not found in URL.");
    }
  }, []);

  const handleFileRead = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      setTempFile(false);
      return;
    }

    if (file.size > 5242880) {
      BOM.AlertMsg(cnt.WARNING, "File size cannot exceed 5 MB");
      event.target.value = "";
      return;
    }

    if (file.type.toLowerCase() !== "application/pdf") {
      BOM.AlertMsg(cnt.WARNING, "Document type must be PDF.");
      event.target.value = "";
      return;
    }

    const base64 = await BOM.convertBase64(file);
    let strB64 = base64.split("base64,")[1];
    setTempFile(strB64);
  };

  const uploadFile = () => {
    if (!tempFile || !docCategory) {
      BOM.AlertMsg(cnt.WARNING, "Document Type and file upload are required");
      return;
    }

    setDocuments([
      ...documents,
      {
        docCategory,
        base64: tempFile,
        docType: "company",
        isNew: true,
      },
    ]);

    setTempFile(false);
    setDocCategory("");
    document.getElementById("documentInputFile").value = "";
    document.getElementById("documentInputSelect").value = "";
  };

  const removeItem = (indexToRemove) => {
    if (!documents[indexToRemove].isNew) {
      return;
    }
    setDocuments(documents.filter((_, index) => index !== indexToRemove));
  };

  const getBanks = () => {
    
    let body = {};
    BOM.FetchReqAction(body, api.GetProspectBank, (err, res) => {
      //console.log("check banklist", res);
      if (err) {
        console.log("check banklist err", res);
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setBankList(res.bankListing);
      }
    });
  };

  const getOtherUsersOfCompany = (primaryContacts = [], criteria = "A") => {
    BOM.LoadAlert(cnt.LOAD, "Processing");
    let body = {
      profileId,
      companyId,
      userId: "",
      criteria,
    };

    BOM.FetchReqActionUnauthorized(body, api.GetUser, (err, res) => {
      if (err) {
        const AllUsers = [];
        const filterOutPrimaryAccount = [];
      } else {
        const AllUsers = res.userListing;
        const filterOutPrimaryAccount = AllUsers.filter(
          (el) => !primaryContacts.some((_con) => _con.USERID === el.USERID)
        );
        setOtherContactData((prev) => [
          ...prev,
          ...filterOutPrimaryAccount.map((el) => ({ ...el, criteria })),
        ]);
      }
    });
  };

  const getDetailById = (token) => {
    BOM.LoadAlert(cnt.LOAD, "Processing");
    const body = { token };

    BOM.FetchReqActionUnauthorized(body, api.GetUnauthorizedCompany, (err, res) => {
      
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {

        getCountry();
        getSpecDoc(token);

        let companyDetail = res.companyDetail;
        const primaryContacts = [
          {
            COMPANY_ID: companyDetail.COMPANY_ID,
            COMPANY_NAME: companyDetail.COMPANY_NAME,
            USER_FIRSTNAME: "Louis",
            USER_LASTNAME: companyDetail.CONTACT_DATA.CONTACT_PERSON,
            USERNAME: companyDetail.CONTACT_DATA.CONTACT_EMAIL,
            USERID: companyDetail.CONTACT_DATA.CONTACT_1_PROFILE_ID,
          },
          {
            COMPANY_ID: companyDetail.COMPANY_ID,
            COMPANY_NAME: companyDetail.COMPANY_NAME,
            USER_FIRSTNAME: "Louis",
            USER_LASTNAME: companyDetail.CONTACT_DATA.OTHER_CONTACT_PERSON,
            USERNAME: companyDetail.CONTACT_DATA.OTHER_EMAIL,
            USERID: companyDetail.CONTACT_DATA.CONTACT_2_PROFILE_ID,
          },
        ];
        getOtherUsersOfCompany(primaryContacts, "A");
        getOtherUsersOfCompany(primaryContacts, "U");
        getOtherUsersOfCompany(primaryContacts, "R");
        setCompanyDetail(companyDetail);
        setPrimaryData(companyDetail.CONTACT_DATA);
        setShippingData(companyDetail.SHIP_DATA);
        setBillingData(companyDetail.BILL_DATA);
        setBankData(companyDetail.BANK_DATA);
        onChooseCompanyType(companyDetail);

        // Set values for react-hook-form
        setValue("companyId", companyDetail.COMPANY_ID);
        setValue("companyName", companyDetail.COMPANY_NAME);
        setValue("clientTitle", companyDetail.CLIENT_TITLE);
        setValue("clientType", companyDetail.CLIENT_TYPE);
        setValue("bvn", companyDetail.BVN);
        setValue("regno", companyDetail.COMPANY_REGNO); // Fixed: Use COMPANY_REGNO
        setValue("vatId", companyDetail.COMPANY_VAT_ID);
        setValue("tradingName", companyDetail.COMPANY_TRADING_NAME);
        setValue("taxNum", companyDetail.COMPANY_TAX);
        setValue("email", companyDetail.COMPANY_EMAIL);
        setValue("website", companyDetail.COMPANY_WEBSITE);
        setValue("contactPerson", companyDetail.CONTACT_DATA.CONTACT_PERSON);
        setValue("officePhone", companyDetail.CONTACT_DATA.OFFICE_PHONE);
        setValue("contactEmail", companyDetail.CONTACT_DATA.CONTACT_EMAIL);
        setValue("contactPerson2", companyDetail.CONTACT_DATA.OTHER_CONTACT_PERSON);
        setValue("officePhone2", companyDetail.CONTACT_DATA.OTHER_OFFICE_PHONE);
        setValue("contactEmail2", companyDetail.CONTACT_DATA.OTHER_EMAIL);
        setValue("userId", companyDetail.CONTACT_DATA.CONTACT_1_PROFILE_ID);
        setValue("userId2", companyDetail.CONTACT_DATA.CONTACT_2_PROFILE_ID);
        setValue("countryId", companyDetail.COUNTRY_ID);
        setValue("provinceId", companyDetail.PROVINCE_ID);
        setValue("cityId", companyDetail.CITY_ID);
        setValue("address1", companyDetail.COMPANY_ADDRESS_1);
        setValue("address2", companyDetail.COMPANY_ADDRESS_2);
        setValue("postCode", companyDetail.COMPANY_POSTCODE);
        setValue("shipCountryId", companyDetail.SHIP_DATA.SHIPPING_COUNTRY_ID);
        setValue("shipProvinceId", companyDetail.SHIP_DATA.SHIPPING_PROVINCE_ID);
        setValue("shipCityId", companyDetail.SHIP_DATA.SHIPPING_CITY_ID);
        setValue("shipAddress1", companyDetail.SHIP_DATA.SHIPPING_ADDRESS_1);
        setValue("shipAddress2", companyDetail.SHIP_DATA.SHIPPING_ADDRESS_2);
        setValue("shipPostCode", companyDetail.SHIP_DATA.SHIPPING_POST_CODE);
        setValue("billCountryId", companyDetail.BILL_DATA.BILLING_COUNTRY_ID);
        setValue("billProvinceId", companyDetail.BILL_DATA.BILLING_PROVINCE_ID);
        setValue("billCityId", companyDetail.BILL_DATA.BILLING_CITY_ID);
        setValue("billAddress1", companyDetail.BILL_DATA.BILLING_ADDRESS_1);
        setValue("billAddress2", companyDetail.BILL_DATA.BILLING_ADDRESS_2);
        setValue("billPostCode", companyDetail.BILL_DATA.BILLING_POST_CODE);
        setValue("companyTypeName", companyDetail.COMPANY_TYPE_NAME);
        setValue("investorType", companyDetail.INVESTOR_TYPE);
        setValue("regDate", companyDetail.COMPANY_REG_DATE);
        setValue("dateOfBirth", companyDetail.DOB);
        setValue("gender", companyDetail.GENDER);
        setValue("businessStartDate", companyDetail.BUSINESS_START_DATE);
        setValue("businessType", companyDetail.BUSINESS_TYPE);
        if (companyDetail.BANK_DATA && companyDetail.BANK_DATA.length > 0) {
          const bank = companyDetail.BANK_DATA[0];
          setValue("bankId", bank.BANK_ID || "");
          setValue("bankName", bank.BANK_NAME || "");
          setValue("accountName", bank.ACC_NAME || "");
          setValue("accountType", bank.ACC_TYPE || "");
          setValue("accountNumber", bank.ACC_NUM || "");
        }

        getGlobalProvince(companyDetail.COUNTRY_ID, setProvincePrimaryData);
        getGlobalProvince(
          companyDetail.BILL_DATA.BILLING_COUNTRY_ID,
          setProvinceBillingData
        );
        getGlobalProvince(
          companyDetail.SHIP_DATA.SHIPPING_COUNTRY_ID,
          setProvinceShippingData
        );
        getGlobalCity(companyDetail.PROVINCE_ID, setCityPrimaryData);
        getGlobalCity(
          companyDetail.SHIP_DATA.SHIPPING_PROVINCE_ID,
          setCityShippingData
        );
        getGlobalCity(
          companyDetail.BILL_DATA.BILLING_PROVINCE_ID,
          setCityBillingData
        );

        dispatch({
          type: cnt.RECORD_STATUS,
          payload: companyDetail,
        });
      }
    });
  };

  const getSpecDoc = (data) => {
    BOM.LoadAlert(cnt.LOAD, "Processing");
    const body = { token: data };

    BOM.FetchReqActionUnauthorized(body, api.GetUnauthorizedCompanyDocuments, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setDocuments(res.docListing);
      }
    });
  };

  const onChooseCompanyType = (obj) => {
    switch (obj.COMPANY_TYPE_ID) {
      case "CT2022012400003":
        setIsFunder(true);
        switch (obj.INVESTOR_TYPE.toLowerCase()) {
          case "individual":
            setIsIndividual(true);
            break;
          default:
            setIsIndividual(false);
            break;
        }
        break;
      default:
        setIsFunder(false);
        setIsIndividual(false);
        break;
    }
  };

  const getCountry = () => {
    let body = {
      countryId: "",
    };

    BOM.FetchReqActionUnauthorized(body, api.GetCountry, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setCountryData(res.countryListing);
      }
    });
  };

  const getProvince = (countryId, type) => {
    if (!countryId) return;

    switch (type.toLowerCase()) {
      case "primary":
        getGlobalProvince(countryId, setProvincePrimaryData);
        break;
      case "shipping":
        getGlobalProvince(countryId, setProvinceShippingData);
        break;
      case "billing":
        getGlobalProvince(countryId, setProvinceBillingData);
        break;
    }
  };

  const getCity = (stateId, type) => {
    if (!stateId) return;

    switch (type.toLowerCase()) {
      case "primary":
        const provinceObj = provincePrimaryData.find(
          (item) => item.ID === stateId
        );
        setValue("finsysProviceId", provinceObj?.FINSYS_ID);
        getGlobalCity(stateId, setCityPrimaryData);
        break;
      case "shipping":
        getGlobalCity(stateId, setCityShippingData);
        break;
      case "billing":
        getGlobalCity(stateId, setCityBillingData);
        break;
    }
  };

  function getGlobalProvince(countryId, setProvince) {
    let body = {
      profileId,
      countryId,
    };
    BOM.FetchReqActionUnauthorized(body, api.GetCountry, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setProvince(res.provinceListing);
      }
    });
  }

  function getGlobalCity(stateId, setCity) {
    if (!stateId) return;
    let body = {
      profileId,
      stateId,
    };

    BOM.FetchReqActionUnauthorized(body, api.GetCity, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setCity(res.cityListing);
      }
    });
  }

  const onSelectAddressAs = (key) => {
    if (
      !getValues("countryId") ||
      !getValues("provinceId") ||
      !getValues("cityId")
    ) {
      BOM.AlertMsg(
        cnt.WARNING,
        "Fields with * under Primary Address are required."
      );
      $("#shipping").prop("checked", false);
      $("#billing").prop("checked", false);
      setIsShipAsPrim(false);
      setIsBillAsPrim(false);
      return;
    }

    switch (key) {
      case "shipping":
        if (!isShipAsPrim) {
          setValue("shipCountryId", getValues("countryId"));
          setValue("shipProvinceId", getValues("provinceId"));
          setValue("shipCityId", getValues("cityId"));
          setValue("shipAddress1", getValues("address1"));
          setValue("shipAddress2", getValues("address2"));
          setValue("shipPostCode", getValues("postCode"));
          setIsShipAsPrim(true);
        } else {
          setValue("shipCountryId", "");
          setValue("shipProvinceId", "");
          setValue("shipCityId", "");
          setValue("shipAddress1", "");
          setValue("shipAddress2", "");
          setValue("shipPostCode", "");
          setIsShipAsPrim(false);
        }
        break;
      case "billing":
        if (!isBillAsPrim) {
          setValue("billCountryId", getValues("countryId"));
          setValue("billProvinceId", getValues("provinceId"));
          setValue("billCityId", getValues("cityId"));
          setValue("billAddress1", getValues("address1"));
          setValue("billAddress2", getValues("address2"));
          setValue("billPostCode", getValues("postCode"));
          setIsBillAsPrim(true);
        } else {
          setValue("billCountryId", "");
          setValue("billProvinceId", "");
          setValue("billCityId", "");
          setValue("billAddress1", "");
          setValue("billAddress2", "");
          setValue("billPostCode", "");
          setIsBillAsPrim(false);
        }
        break;
    }
  };

  const formSubmit = (formValues) => {
    /*
    const newDocuments = documents
      .filter((doc) => doc.DOC_OBJECT && doc.DOC_OBJECT.length > 0)
      .map((doc) => ({
        base64: doc.DOC_OBJECT,
        docType: 'companytoken',
        docCategory: doc.DOC_CATEGORY,
      }));
    */

    const newDocuments = documents
      .filter((doc) => doc.isNew)
      .map((doc) => ({
        base64: doc.base64,
        docType: 'companytoken',
        docCategory: doc.docCategory,
      }));

    let body = {
      token: compToken,
      ...formValues,
    };

    console.log("form values new new doc", newDocuments);

    BOM.LoadAlert(cnt.LOAD, "Processing");

    BOM.FetchReqActionUnauthorized(body, api.UpdateUnauthorizedCompany, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {

        if (newDocuments.length > 0) {
          let docBody = {
            docTypeId: compToken,
            documents: newDocuments,
            channel: "web",
          };

          console.log("form values doc", docBody);

          BOM.FetchReqActionUnauthorized(
            docBody,
            api.CreateUnauthorizedCompanyDocument,
            (docErr, docRes) => {

              console.log("doc body output result", docRes);
              console.log("doc body output error", docErr);

              if (docErr) {
                BOM.AlertMsg(
                  cnt.WARNING,
                  `Company details updated successfully, but document upload failed: ${docErr}`
                );
              } else {
                BOM.AlertMsg(cnt.SUCCESS, "Record saved successfully.");
              }
            }
          );
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Record saved successfully.");
        }
      }
    });
  };

  const onFormInvalid = (errors) => {
    const elementsInTab = {
      contactInfo: [
        "contactPerson",
        "contactEmail",
        "officePhone",
        "contactPerson2",
        "officePhone2",
        "contactEmail2",
      ],
      addressInfo: [
        "countryId",
        "provinceId",
        "cityId",
        "address1",
        "billAddress1",
        "billCountryId",
        "billProvinceId",
        "billCityId",
        "shipAddress1",
        "shipCountryId",
        "shipProvinceId",
        "shipCityId",
      ],
      statutoryInfo: [
        "regno",
        "taxNum",
        "regDate",
        "dateOfBirth",
        "gender",
        "businessStartDate",
        "businessType",
        "bankId",
        "bankName",
        "accountName",
        "accountType",
        "accountNumber",
      ],
    };
    const errorKeys = Object.keys(errors);
    const errorTab = Object.keys(elementsInTab).find((tab) =>
      elementsInTab[tab].some((key) => errorKeys.includes(key))
    );
    if (errorTab) {
      const element = document.querySelector(`a[href="#${errorTab}"]`);
      if (element) {
        element.click();
      }
    }
    BOM.AlertMsg(cnt.WARNING, "Please fill all required fields.");
  };

  return (
    <React.Fragment>
      <BgImgFac />
      <div style={{ margin: "0 20px", padding: "20px" }}>
      <div style={{ marginBottom: "20px" }}>
        <img src={Logo} alt="Company Logo" style={{ height: "20px" }} />
      </div>
      <form
        method="POST"
        id="NewItemForm"
        autoComplete="off"
        onSubmit={handleSubmit(formSubmit, onFormInvalid)}
      >
        <div className="animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox">
                <div className="ibox-title">
                  <h5>{appLabel.editCompany}</h5>
                  <div className="ibox-tools">
                    <button
                      type="submit"
                      className="btn btn-primary btn-xs"
                      id="saveBtn"
                      style={{ marginRight: "10px" }}
                    >
                      <i className="fa fa-save" />
                      &nbsp; Save
                    </button>
                    <Link
                      to="/dashboard"
                      className="btn btn-primary btn-xs"
                    >
                      <i className="fa fa-arrow-circle-left" />
                      &nbsp;
                      {appLabel.backBtn}
                    </Link>
                  </div>
                </div>
                <div className="ibox-content contentCard panel-primary">
                  <div className="row">
                    <div className="col-sm-12">
                      <label className="al-heading">
                        <i className="fa fa-circle-o text-navy"></i>&nbsp;
                        {appLabel.generalInfo}
                      </label>
                      <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                      <div className={`row form-group col-md-6`}>
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">
                            {appLabel.companyType} &nbsp;
                          </label>
                        </div>
                        <div className="col-md-7">
                          <select
                            className="form-control input-sm"
                            {...register("companyTypeName")}
                            // Set default value on load
                            defaultValue={companyDetail.COMPANY_TYPE_NAME}
                          >
                            <option value="">{appLabel.choose}</option>
                            <option value="Buyer">Buyer</option>
                            <option value="Funder">Funder</option>
                            <option value="Supplier">Supplier</option>
                          </select>
                        </div>
                      </div>
                      <div className={`row form-group col-md-6 ${isFunder ? "hide" : ""}`}>
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.companyName}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.companyName}
                            {...register("companyName")}
                          />
                        </div>
                      </div>
                      <div className={`row form-group col-md-6 ${isFunder ? "" : "hide"}`}>
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.investorType}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={companyDetail.INVESTOR_TYPE}
                            {...register("investorType")}
                          />
                        </div>
                      </div>
                      <div className={`row form-group col-md-6 ${isFunder ? "" : "hide"}`}>
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.investorName}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.investorName}
                            {...register("companyName")}
                          />
                        </div>
                      </div>
                      <div className={`row form-group col-md-6 ${isFunder && isIndividual ? "" : "hide"}`}>
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.clientTitle}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.clientTitle}
                            {...register("clientTitle")}
                          />
                        </div>
                      </div>
                      <div className={`row form-group col-md-6 ${isFunder && isIndividual ? "" : "hide"}`}>
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.clientType}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.clientType}
                            {...register("clientType")}
                          />
                        </div>
                      </div>
                      <div className={`row form-group col-md-6 ${isFunder && isIndividual ? "" : "hide"}`}>
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.bvnRcNumber}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.bvnRcNumber}
                            {...register("bvn")}
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.companyRegNo} <span className="asterisks">*</span></label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.companyRegNo}
                            {...register("regno", { 
                              required: "Field is required.",
                              pattern: {
                                value: /^[a-zA-Z0-9]{8,}$/,
                                message: "Registration number must be at least 8 alphanumeric characters."
                              } 
                            })}
                          />
                          <span className="asterisks">{errors?.regno?.message}</span>
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.vatId}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.vatId}
                            {...register("vatId")}
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.tradingName}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.tradingName}
                            {...register("tradingName")}
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.email} <span className="asterisks">*</span></label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.email}
                            {...register("email", {
                              required: "Field is required.",
                              pattern: {
                                value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                                message: "Email must be valid.",
                              },
                            })}
                          />
                          <span className="asterisks">{errors?.email?.message}</span>
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.companyTax} <span className="asterisks">*</span></label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.companyTax}
                            {...register("taxNum", { 
                              required: "Field is required.",
                              pattern: {
                                value: /^[a-zA-Z0-9]{11}$/,
                                message: "Company TIN must be 11 alphanumeric characters."
                              }
                            })}
                          />
                          <span className="asterisks">{errors?.taxNum?.message}</span>
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">{appLabel.website}</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={appLabel.website}
                            {...register("website", {
                              pattern: {
                                  value: /^www\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/i,
                                  message: "Please use 'www.example.com' format."
                              }
                            })}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <label className="al-heading">
                        <i className="fa fa-circle-o text-navy"></i>&nbsp; {appLabel.otherInfo}
                      </label>
                      <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                      <ul className="nav nav-tabs">
                        <li className="active">
                          <a data-toggle="tab" href="#contactInfo" target="_self">
                            <i className="fa fa-users text-navy" />
                            &nbsp;{appLabel.contactInfo}
                          </a>
                        </li>
                        <li>
                          <a data-toggle="tab" href="#addressInfo" target="_self">
                            <i className="fa fa-home text-navy" />
                            &nbsp;{appLabel.addressInfo}
                          </a>
                        </li>
                        <li>
                          <a data-toggle="tab" href="#statutoryInfo" target="_self">
                            <i className="fa fa-tag text-navy" />
                            &nbsp;{appLabel.statutoryInfo}
                          </a>
                        </li>
                        <li>
                          <a data-toggle="tab" href="#documentInfo" target="_self">
                            <i className="fa fa-file-pdf-o text-navy" />
                            &nbsp;{appLabel.documentInfo}
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div className="tab-pane active" id="contactInfo">
                          <div className="row" style={{ marginTop: "20px" }}>
                            <div className="col-sm-12">
                              <label className="al-heading">
                                <i className="fa fa-circle-o text-navy"></i>&nbsp; {appLabel.primaryContact}
                              </label>
                              <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.contactName} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.contactName}
                                    {...register("contactPerson", { required: "Field is required." })}
                                  />
                                  <span className="asterisks">{errors?.contactPerson?.message}</span>
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.officePhone}</label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.officePhone}
                                    {...register("officePhone")}
                                  />
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.contactEmail} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.contactEmail}
                                    {...register("contactEmail", {
                                      required: "Field is required.",
                                      pattern: {
                                        value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                                        message: "Email must be valid.",
                                      },
                                    })}
                                  />
                                  <span className="asterisks">{errors?.contactEmail?.message}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12">
                              <label className="al-heading">
                                <i className="fa fa-circle-o text-navy"></i>&nbsp; {appLabel.otherContact}
                              </label>
                              <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.contactName} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.contactName}
                                    {...register("contactPerson2", { required: "Field is required." })}
                                  />
                                  <span className="asterisks">{errors?.contactPerson2?.message}</span>
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.officePhone}</label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.officePhone}
                                    {...register("officePhone2")}
                                  />
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.contactEmail} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.contactEmail}
                                    {...register("contactEmail2", {
                                      required: "Field is required.",
                                      pattern: {
                                        value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                                        message: "Email must be valid.",
                                      },
                                    })}
                                  />
                                  <span className="asterisks">{errors?.contactEmail2?.message}</span>
                                </div>
                              </div>
                            </div>
                            <OtherContacts data={otherContactData} userData={{ profileId }} />
                          </div>
                        </div>
                        <div className="tab-pane" id="addressInfo">
                          <div className="row" style={{ marginTop: "20px" }}>
                            <div className="col-sm-12">
                              <label className="al-heading">
                                <i className="fa fa-circle-o text-navy"></i>&nbsp; {appLabel.primaryAddress}
                              </label>
                              <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.country} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <select
                                    className="form-control input-sm"
                                    value={getValues("countryId")}
                                    {...register("countryId", {
                                      onChange: (e) => getProvince(e.target.value, "primary"),
                                      required: "Field is required.",
                                    })}
                                  >
                                    <option value="">{appLabel.choose}</option>
                                    {countryData.map((item, index) => (
                                      <option value={item.ID} key={index}>
                                        {item.COUNTRY_NAME} {/* Fixed: Use COUNTRY_NAME */}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="asterisks">{errors?.countryId?.message}</span>
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.province} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <select
                                    className="form-control input-sm"
                                    value={getValues("provinceId")}
                                    {...register("provinceId", {
                                      onChange: (e) => getCity(e.target.value, "primary"),
                                      required: "Field is required.",
                                    })}
                                  >
                                    <option value="">{appLabel.choose}</option>
                                    {provincePrimaryData?.map((item, index) => (
                                      <option value={item.ID} key={index}>
                                        {item.PROVINCE_NAME}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="asterisks">{errors?.provinceId?.message}</span>
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.city} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <select
                                    className="form-control input-sm"
                                    value={getValues("cityId")}
                                    {...register("cityId", { required: "Field is required." })}
                                  >
                                    <option value="">{appLabel.choose}</option>
                                    {cityPrimaryData.map((item, index) => (
                                      <option value={item.ID} key={index}>
                                        {item.CITY_NAME}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="asterisks">{errors?.cityId?.message}</span>
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.address} 1 <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={`${appLabel.address} 1`}
                                    {...register("address1", { required: "Field is required." })}
                                  />
                                  <span className="asterisks">{errors?.address1?.message}</span>
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.address} 2</label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={`${appLabel.address} 2`}
                                    {...register("address2")}
                                  />
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.postCode}</label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={`${appLabel.postCode}`}
                                    {...register("postCode")}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12">
                              <label className="al-heading">
                                <i className="fa fa-circle-o text-navy"></i>&nbsp; {appLabel.shippingAddress}
                              </label>
                              <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                              <div className="col-md-12">
                                <label className="al-subtitle">
                                  <i className="fa fa-circle text-navy" /> &nbsp;{appLabel.sameAsPrimary}&nbsp;
                                  <input
                                    onClick={() => {
                                      setIsShipAsPrim(!isShipAsPrim);
                                      onSelectAddressAs("shipping");
                                    }}
                                    style={{ cursor: "pointer" }}
                                    type="checkbox"
                                    id="shipping"
                                  />
                                </label>
                                <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                                <div className={`alert alert-warning text-center ${isShipAsPrim ? "" : "hide"}`}>
                                  <a className="alert-link">{appLabel.shipSameAsPrimaryAddress}</a>
                                </div>
                              </div>
                              <div className={`${!isShipAsPrim ? "" : "hide"}`}>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.country} <span className="asterisks">*</span></label>
                                  </div>
                                  <div className="col-md-7">
                                    <select
                                      className="form-control input-sm"
                                      value={getValues("shipCountryId")}
                                      {...register("shipCountryId", {
                                        onChange: (e) => getProvince(e.target.value, "shipping"),
                                        required: "Field is required.",
                                      })}
                                    >
                                      <option value="">{appLabel.choose}</option>
                                      {countryData.map((item, index) => (
                                        <option value={item.ID} key={index}>
                                          {item.COUNTRY_NAME}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="asterisks">{errors?.shipCountryId?.message}</span>
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.province} <span className="asterisks">*</span></label>
                                  </div>
                                  <div className="col-md-7">
                                    <select
                                      className="form-control input-sm"
                                      value={getValues("shipProvinceId")}
                                      {...register("shipProvinceId", {
                                        onChange: (e) => getCity(e.target.value, "shipping"),
                                        required: "Field is required.",
                                      })}
                                    >
                                      <option value="">{appLabel.choose}</option>
                                      {provinceShippingData?.map((item, index) => (
                                        <option value={item.ID} key={index}>
                                          {item.PROVINCE_NAME}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="asterisks">{errors?.shipProvinceId?.message}</span>
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.city} <span className="asterisks">*</span></label>
                                  </div>
                                  <div className="col-md-7">
                                    <select
                                      className="form-control input-sm"
                                      value={getValues("shipCityId")}
                                      {...register("shipCityId", { required: "Field is required." })}
                                    >
                                      <option value="">{appLabel.choose}</option>
                                      {cityShippingData.map((item, index) => (
                                        <option value={item.ID} key={index}>
                                          {item.CITY_NAME}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="asterisks">{errors?.shipCityId?.message}</span>
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.address} 1 <span className="asterisks">*</span></label>
                                  </div>
                                  <div className="col-md-7">
                                    <input
                                      type="text"
                                      className="form-control input-sm"
                                      placeholder={`${appLabel.address} 1`}
                                      {...register("shipAddress1", { required: "Field is required." })}
                                    />
                                    <span className="asterisks">{errors?.shipAddress1?.message}</span>
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.address} 2</label>
                                  </div>
                                  <div className="col-md-7">
                                    <input
                                      type="text"
                                      className="form-control input-sm"
                                      placeholder={`${appLabel.address} 2`}
                                      {...register("shipAddress2")}
                                    />
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.postCode}</label>
                                  </div>
                                  <div className="col-md-7">
                                    <input
                                      type="text"
                                      className="form-control input-sm"
                                      placeholder={`${appLabel.postCode}`}
                                      {...register("shipPostCode")}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12">
                              <label className="al-heading">
                                <i className="fa fa-circle-o text-navy"></i>&nbsp; {appLabel.billingAddress}
                              </label>
                              <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                              <div className="col-md-12">
                                <label className="al-subtitle">
                                  <i className="fa fa-circle text-navy" /> &nbsp;{appLabel.sameAsPrimary}&nbsp;
                                  <input
                                    onClick={() => {
                                      setIsBillAsPrim(!isBillAsPrim);
                                      onSelectAddressAs("billing");
                                    }}
                                    style={{ cursor: "pointer" }}
                                    type="checkbox"
                                    id="billing"
                                  />
                                </label>
                                <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                                <div className={`alert alert-warning text-center ${isBillAsPrim ? "" : "hide"}`}>
                                  <a className="alert-link">{appLabel.billSameAsPrimaryAddress}</a>
                                </div>
                              </div>
                              <div className={`${!isBillAsPrim ? "" : "hide"}`}>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.country} <span className="asterisks">*</span></label>
                                  </div>
                                  <div className="col-md-7">
                                    <select
                                      className="form-control input-sm"
                                      value={getValues("billCountryId")}
                                      {...register("billCountryId", {
                                        onChange: (e) => getProvince(e.target.value, "billing"),
                                        required: "Field is required.",
                                      })}
                                    >
                                      <option value="">{appLabel.choose}</option>
                                      {countryData.map((item, index) => (
                                        <option value={item.ID} key={index}>
                                          {item.COUNTRY_NAME}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="asterisks">{errors?.billCountryId?.message}</span>
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.province} <span className="asterisks">*</span></label>
                                  </div>
                                  <div className="col-md-7">
                                    <select
                                      className="form-control input-sm"
                                      value={getValues("billProvinceId")}
                                      {...register("billProvinceId", {
                                        onChange: (e) => getCity(e.target.value, "billing"),
                                        required: "Field is required.",
                                      })}
                                    >
                                      <option value="">{appLabel.choose}</option>
                                      {provinceBillingData?.map((item, index) => (
                                        <option value={item.ID} key={index}>
                                          {item.PROVINCE_NAME}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="asterisks">{errors?.billProvinceId?.message}</span>
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.city} <span className="asterisks">*</span></label>
                                  </div>
                                  <div className="col-md-7">
                                    <select
                                      className="form-control input-sm"
                                      value={getValues("billCityId")}
                                      {...register("billCityId", { required: "Field is required." })}
                                    >
                                      <option value="">{appLabel.choose}</option>
                                      {cityBillingData.map((item, index) => (
                                        <option value={item.ID} key={index}>
                                          {item.CITY_NAME}
                                        </option>
                                      ))}
                                    </select>
                                    <span className="asterisks">{errors?.billCityId?.message}</span>
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.address} 1 <span className="asterisks">*</span></label>
                                  </div>
                                  <div className="col-md-7">
                                    <input
                                      type="text"
                                      className="form-control input-sm"
                                      placeholder={`${appLabel.address} 1`}
                                      {...register("billAddress1", { required: "Field is required." })}
                                    />
                                    <span className="asterisks">{errors?.billAddress1?.message}</span>
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.address} 2</label>
                                  </div>
                                  <div className="col-md-7">
                                    <input
                                      type="text"
                                      className="form-control input-sm"
                                      placeholder={`${appLabel.address} 2`}
                                      {...register("billAddress2")}
                                    />
                                  </div>
                                </div>
                                <div className="row form-group col-md-6">
                                  <div className="col-md-4 text-left">
                                    <label className="al-subtitle">{appLabel.postCode}</label>
                                  </div>
                                  <div className="col-md-7">
                                    <input
                                      type="text"
                                      className="form-control input-sm"
                                      placeholder={`${appLabel.postCode}`}
                                      {...register("billPostCode")}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="statutoryInfo">
                          <div className="row" style={{ marginTop: "20px" }}>
                            <div className="col-sm-12">
                              <label className="al-heading">
                                <i className="fa fa-circle-o text-navy"></i>&nbsp; {appLabel.generalInfo}
                              </label>
                              <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                              <div className={`row form-group col-md-6 ${isIndividual ? "hide" : ""}`}>
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.companyRegDate} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="date"
                                    className="form-control input-sm"
                                    defaultValue={companyDetail.COMPANY_REG_DATE}
                                    {...register("regDate", { required: "Field is required." })}
                                  />
                                  <span className="asterisks">{errors?.regDate?.message}</span>
                                </div>
                              </div>
                              <div className={`row form-group col-md-6 ${isIndividual ? "" : "hide"}`}>
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.dateOfBirth}</label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    defaultValue={companyDetail.DOB}
                                    {...register("dateOfBirth")}
                                  />
                                </div>
                              </div>
                              <div className={`row form-group col-md-6 ${isIndividual ? "" : "hide"}`}>
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.gender}</label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    defaultValue={companyDetail.GENDER}
                                    {...register("gender")}
                                  />
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.businessStartDate}</label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="date"
                                    className="form-control input-sm"
                                    defaultValue={companyDetail.BUSINESS_START_DATE}
                                    {...register("businessStartDate")}
                                  />
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.businessType}</label>
                                </div>
                                <div className="col-md-7">
                                  {/*
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    defaultValue={companyDetail.BUSINESS_TYPE}
                                    {...register("businessType")}
                                  />
                                  */}
                                  <select
                                      className="form-control input-sm"
                                      {...register("businessType")}
                                  >
                                      <option value="">{appLabel.choose}</option>
                                      <option value="Public">Public</option>
                                      <option value="Private">Private</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-12">
                              <label className="al-heading">
                                <i className="fa fa-circle-o text-navy"></i>&nbsp; {appLabel.bankInformation}
                              </label>
                              <div className="hr-line-dashed" style={{ marginTop: 0 }} />
                              {/*
                              <div className="table-responsive">
                                {bankData.length === 0 ? (
                                  <div className="alert alert-warning text-center">
                                    <a className="alert-link">{appLabel.noDataInTableMsg}</a>
                                  </div>
                                ) : (
                                  <table
                                    className="footable table table-stripped toggle-arrow-tiny"
                                    data-page-size="10"
                                    data-filter="#filter"
                                  >
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>{appLabel.bankName}</th>
                                        <th>{appLabel.accountNumber}</th>
                                        <th>{appLabel.accountName}</th>
                                        <th>{appLabel.accountType}</th>
                                        <th>{appLabel.branchCode}</th>
                                        <th>{appLabel.nuban}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {bankData.map((bank, index) => (
                                        <tr className="gradeX" key={index}>
                                          <td>{index + 1}</td>
                                          <td>{bank.BANK_NAME}</td>
                                          <td>{bank.ACC_NUM}</td>
                                          <td>{bank.ACC_NAME}</td>
                                          <td>{bank.ACC_TYPE}</td>
                                          <td>{bank.BRANCH_CODE}</td>
                                          <td>{bank.NUBAN}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <td colSpan="7">
                                          <ul className="pagination pull-right"></ul>
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                )}
                              </div>
                              */}
                              
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">
                                    {appLabel.bankName} <span className="asterisks">*</span>
                                  </label>
                                </div>
                                <div className="col-md-7">
                                  <select
                                    className="form-control input-sm"
                                    {...register("bankId", { required: "Field is required." })}
                                  >
                                    <option value="">{appLabel.choose}</option>
                                    {bankList.map((item, index) => (
                                      <option value={item.BANK_ID} key={index}>
                                        {item.BANK_NAME}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="asterisks">{errors?.bankId?.message}</span>
                                </div>
                              </div>

                              {/*
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.bankName} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.bankName}
                                    {...register("bankName", { required: "Field is required." })}
                                  />
                                  <span className="asterisks">{errors?.bankName?.message}</span>
                                </div>
                              </div>
                              */}

                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.accountName} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.accountName}
                                    {...register("accountName", { required: "Field is required." })}
                                  />
                                  <span className="asterisks">{errors?.accountName?.message}</span>
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.accountNumber} <span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.accountNumber}
                                    {...register("accountNumber", { 
                                      required: "Field is required.",
                                      pattern: {
                                        value: /^\d{13}$/,
                                        message: "Account number must be 13 digits."
                                      }
                                    })}
                                  />
                                  <span className="asterisks">{errors?.accountNumber?.message}</span>
                                </div>
                              </div>
                              <div className="row form-group col-md-6">
                                <div className="col-md-4 text-left">
                                  <label className="al-subtitle">{appLabel.accountType}<span className="asterisks">*</span></label>
                                </div>
                                <div className="col-md-7">
                                  {/*
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    placeholder={appLabel.accountType}
                                    {...register("accountType")}
                                  />
                                  */}
                                  <select
                                      className="form-control input-sm"
                                      {...register("accountType")}
                                  >
                                      <option value="">{appLabel.choose}</option>
                                      <option value="Current">Current</option>
                                      <option value="Savings">Savings</option>
                                  </select>
                                </div>
                              </div>

                            </div>


                          </div>
                        </div>


                        <div className="tab-pane" id="documentInfo">
                          <div className="row" style={{ marginTop: "30px" }}>
                            <div className="col-sm-12">
                              {documents.length === 0 ? (
                                <div className="alert alert-warning text-center">
                                  <a className="alert-link">{appLabel.noDocumentMsg}</a>
                                </div>
                              ) : (
                                <div className="row">
                                  {documents.map((item, index) => (
                                    <div className="col-md-4" key={index}>
                                      <div className="file-box">
                                        <div className="file">
                                          {item.isNew && (
                                            <span
                                              style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "10px",
                                                cursor: "pointer",
                                                zIndex: "10",
                                              }}
                                              onClick={() => removeItem(index)}
                                            >
                                              <i className="fa fa-times-circle text-danger fa-2x" />
                                            </span>
                                          )}
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              !item.isNew &&
                                              BOM.DownloadAction(
                                                item.DOC_OBJECT,
                                                `${item.DOC_ID} ${item.DOC_CATEGORY.toLowerCase()}`
                                              )
                                            }
                                          >
                                            <span className="corner" />
                                            <div className="icon">
                                              <i className="fa fa-file-pdf-o" style={{ color: "#d50000" }} />
                                            </div>
                                            <div className="file-name">
                                              {item.DOC_CATEGORY || item.docCategory}
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                              <div className="hr-line-dashed" style={{ marginTop: "20px" }} />
                              <p className="text-danger">{appLabel.maxFileUploadMsg}</p>
                              <div className="row form-group">
                                <div className="col-md-2 text-left">
                                  <label className="al-subtitle control-label">{appLabel.documentType}</label>
                                </div>
                                <div className="col-md-4">
                                  <select
                                    id="documentInputSelect"
                                    className="form-control input-sm"
                                    value={docCategory}
                                    onChange={(e) => setDocCategory(e.target.value)}
                                  >
                                    <option value="">{appLabel.choose}</option>
                                    {appStatic.documntTypes.map((item, index) => (
                                      <option value={item.id} key={index}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="row form-group">
                                <div className="col-md-2 text-left">
                                  <label className="al-subtitle">{appLabel.documentUpload}</label>
                                </div>
                                <div className="col-md-4">
                                  <input
                                    type="file"
                                    id="documentInputFile"
                                    className="form-control input-sm"
                                    accept=".pdf"
                                    onChange={handleFileRead}
                                  />
                                </div>
                              </div>
                              <div className="row form-group">
                                <div className="col-md-2 text-left" />
                                <div className="col-md-4">
                                  <button
                                    type="button"
                                    onClick={uploadFile}
                                    className="btn btn-primary btn-xs"
                                  >
                                    <i className="fa fa-upload" />
                                    &nbsp; Add Document to List
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    </React.Fragment>
  );
};

export default EditProspectiveCompany;